export interface DbLogItf {
    set(type: string, key: string, data: any): void;
    get(type: string, key: string): any;
    clear(): void;
}
export default {
    dbLog: (dataSource: any = {}) => {
        const fc: DbLogItf = {
            set(type: string, key: string, data: any) {
                if (!(type in dataSource)) {
                    dataSource[type] = {};
                }
                dataSource[type][key] = data;
            },
            get(type: string, key: string): any {
                if (type in dataSource) {
                    return dataSource[type][key] || null;
                }
                return null;
            },
            clear() {
                dataSource = null;
            }
        };
        return fc;
    },
    rowSpan: (dataSource: any = {
        text: '',
        vo: null,
        show: true,
        rowspan: 1
    }): Function => {
        return (vo: any) => {
            if (dataSource.text !== vo.text) {
                if (dataSource.vo) {
                    dataSource.vo = null;
                }
                dataSource.vo = vo;
                dataSource.text = vo.text;
                dataSource.rowspan = 1;
            } else {
                vo.show = false;
                dataSource.rowspan += 1;
                dataSource.vo.rowspan = dataSource.rowspan;
            }
        };
    },
    createSvg: (name: string) => document.createElementNS('http://www.w3.org/2000/svg', name)
};
